import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import * as S from './styles';

const Toast = ({ type, message, autoClose, hideProgress }) => {
  const [toastType, setToastType] = useState('');

  useEffect(() => {
    const changeToastType = value => {
      switch (value) {
        case 'information':
          return toast.info(message);
        case 'warning':
          return toast.warn(message);
        case 'success':
          return toast.success(message);
        case 'error':
          return toast.error(message);
        default:
          return '';
      }
    };

    changeToastType(type);
    setToastType(type);
  }, [message, type]);

  return (
    <S.Toast
      position="bottom-center"
      autoClose={autoClose}
      hideProgressBar={hideProgress}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
      className={`.Toastify__toast--${toastType}`}
    />
  );
};

export default Toast;

Toast.defaultProps = {
  autoClose: 2000,
  hideProgress: false,
};

Toast.propTypes = {
  autoClose: PropTypes.number,
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  hideProgress: PropTypes.bool,
};
